import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { SpInvoicesPage } from '@/components/SpInvoices/SpInvoicesPage'
import { listSearchSchema, withoutListDefaults } from '@/lib/listSearch'
import { inPageSearch } from '@/lib/searchNavigation'

/** Wiring only: the schema and the pruning live in `lib/listSearch`. */
export const Route = createFileRoute('/_app/operations/sp-invoices/')({
  validateSearch: listSearchSchema,
  component: SpInvoicesRoute,
})

function SpInvoicesRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <SpInvoicesPage
      search={search}
      // Filtering and paging replace; opening a record pushes, so Back closes
      // it. Either way the page keeps its scroll.
      onSearchChange={(next, options) =>
        void navigate(inPageSearch(withoutListDefaults, next, options))
      }
    />
  )
}
